export const getProportionedImagePadding = ({ width, height }: { width: number; height: number }) =>
  `${100 / (width / height)}%`;
